module.exports = __webpack_public_path__ + "media/images/senior_home_image-40f462469915d3180797e9228863b548.png";